import config from 'config';

const LOAD = 'horse-racing/my-stable-horse-search/LOAD';
const LOAD_SUCCESS = 'horse-racing/my-stable-horse-search/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/my-stable-horse-search/LOAD_FAIL';
const RESET = 'horse-racing/my-stable-horse-search/RESET';

const initialState = {
  loaded: false,
  horseSearchResults : []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true,
        searchText: action.searchText
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        horseSearchResults: action.result,
        searchText: action.searchText
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
        searchText: action.searchText
      };
    case RESET:
      return {
        ...state,
        horseSearchResults: [],
        searchText: ""
      }
    default:
      return state;
  }
}

export function resetHorses() {
  return {
    type: RESET
  }
}

export function areHorsesLoaded() {
  return false;
}

export function loadHorses(name) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => name ? client.get(config.api.horseRacing.horse, { params: {name}})
                              : Promise.resolve([]),
    searchText: name
  };
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/myStableHorseSearch.js